import React from 'react';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DescriptionIcon from '@material-ui/icons/Description';
import BusinessIcon from '@material-ui/icons/Business';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import Home from '@material-ui/icons/Home';

export default [
    {
        title: 'Dashboard',
        icon: <DashboardIcon />,
        path: '',
        arr: [],
    },
    {
        title: 'Admin',
        icon: <BusinessIcon />,
        path: '',
        arr: [
            {
                path: 'companies',
                title: 'Companies',
            },
            {
                path: 'configs',
                title: 'Configs',
            },
            {
                path: 'leads-testing-tool',
                title: 'Lead Testing Tool',
            },
            {
                path: 'signature-blocks',
                title: 'Signature Blocks',
            },
            {
                path: 'traffic-source-state-groups',
                title: 'Traffic Source State Groups',
            },
            {
                path: 'opt-outs',
                title: 'Opt Outs',
            },
            {
                path: 'ssn-hash',
                title: 'SSN Hashing',
            },
            {
                path: 'set-promo-id',
                title: 'Set Promo Id Counter',
            },
            {
                path: 'payout-strategy-swappers',
                title: 'Payout Strategy Swappers',
            },
        ]
    },
    {
        title: 'Vendor',
        icon: <AccountBalanceIcon />,
        path: '',
        arr: [
            {
                path: 'servicers',
                title: 'Servicers',
            },
            {
                path: 'campaigns',
                title: 'Campaigns',
            },
            {
                path: 'vendor-pause',
                title: 'Vendor Pause',
            },
            {
                path: 'campaign-capacities',
                title: 'Campaign Capacites',
            },
            {
                path: 'campaign-filter-lists',
                title: 'Campaign Filter Lists',
            },
            {
                path: 'pingtrees',
                title: 'Ping Trees',
            },
        ]
    },
    {
        title: 'Affiliate',
        icon: <SupervisorAccountIcon />,
        path: '',
        arr: [
            {
                path: 'affiliates',
                title: 'Affiliates',
            },
            {
                path: 'traffic-sources',
                title: 'Traffic Sources',
            },
            {
                path: 'pixels',
                title: 'Pixels',
            },
            {
                path: 'blocked-sources',
                title: 'Blocked Sources',
            },
        ]
    },
    {
        title: 'Advertiser / Offers',
        icon: <RecordVoiceOverIcon />,
        path: '',
        arr: [
            {
                path: 'advertisers',
                title: 'Advertisers',
            },
            {
                path: 'offers',
                title: 'Offers',
            },
            {
                path: 'websites',
                title: 'Websites',
            },
        ]
    },
    {
        title: 'Reporting',
        icon: <AssignmentIcon />,
        path: '',
        arr: [
            {
                path: 'leads',
                title: 'Leads',
            },
            {
                path: 'leads/short',
                title: 'Short Form Leads',
            },
            {
                path: 'lead-purchase-requests',
                title: 'Lead Purchase Request',
            },
            {
                path: 'loan-request-log',
                title: 'Loan Request Log',
            },
            {
                path: 'pixel-log',
                title: 'Pixel Log',
            },
            {
                path: 'revenueitems',
                title: 'Revenue',
            },
            // {
            //     path: '',
            //     title: 'Current Month',
            // },
            // {
            //     path: '',
            //     title: 'Last Quarter',
            // },
            // {
            //     path: '',
            //     title: 'Year-end Sale',
            // },
            {
                path: 'jvm-stats',
                title: 'JVM Stats',
            },
        ]
    },
    {
        title: 'Posting Docs',
        icon: <DescriptionIcon />,
        path: '',
        arr: [
            {
                path: 'posting',
                title: 'Standard / Price Reject',
            },
            {
                path: 'amp-docs',
                title: 'AMP',
            },
            {
                path: 'lead-purchase-posting',
                title: 'Lead Purchase',
            },
            {
                path: 'lead-purchase-v2-posting',
                title: 'Lead Purchase v2',
            },
            {
                path: 'list-management-posting',
                title: 'List Management',
            },
            {
                path: 'dnp-posting',
                title: 'DNP',
            },
            {
                path: 'lender-feedback-docs',
                title: 'Lender Feedback'
            },
            {
                path: 'offer-event-api-posting',
                title: 'Offer Event API'
            }
        ].sort((a, b) => a.title.localeCompare(b.title))
    },
]